<template>
	<section class="container-fluid">
		<div class="row">
			<div class="col-12">
				<h1>Horses</h1>
			</div>
		</div>
		<div v-if="tenant" class="row">
			<div class="col-12 options">
				<div class="row options-bar">
					<button class="add-item" @click="openAddModal">Add Horse <i class="ss-plus ss-glyphish-filled"></i></button>
					<Search v-on:foundItems="filteredList" defaultText="Search Horses" :items="horses"/>
					<InputSelect v-if="tenant.hasMultiYard" id="id" name="" :options="locations" :form="locationFilter" :errors="{}" class="location-filter"/>
					<div class="horse-count" v-if="tenant.maxHorses && tenant.maxHorses < 9999">
						<span>{{ horseList.length }} / {{ tenant.maxHorses }} Horses Used</span>
						<router-link to="/account">Upgrade Now</router-link>
					</div>
				</div>
			</div>
		</div>
		<div class="row">
			<div class="col-12">
				<List :horses="foundHorses.length ? foundHorses : horses" @edit="editHorse" @history="horseHistory" placeholder="Search horses" @delete="deleteHorse"/>
			</div>
		</div>
		<Add v-if="addOpen" @close="addOpen = false"/>
		<Upgrade v-if="upgradeOpen" @close="upgradeOpen = false"/>
		<Edit v-if="editOpen" @close="editOpen = false" :horse="selected"/>
		<History v-if="historyOpen" @close="historyOpen = false" :horse="selected"/>
		<Delete v-if="deleteOpen" @close="deleteOpen = false" :horse="selected"/>
	</section>
</template>

<script>
import { mapState } from 'vuex'
import List from '../Horses/List.vue'
import Add from '../Horses/Add.vue'
import Upgrade from '../Horses/Upgrade.vue'
import Edit from '../Horses/Edit.vue'
import History from '../Horses/History.vue'
import Delete from '../Horses/Delete.vue'
import Search from '../Form/Search.vue'
import InputSelect from '../Form/InputSelect.vue'

export default { 
	components: {
		List,
		Add,
		Upgrade,
		Edit,
		Delete,
		Search,
		InputSelect,
		History
	},
	data() {
		return {
			selected: null,
			deleteOpen: false,
			editOpen: false,
			historyOpen: false,
			addOpen: false,
			upgradeOpen: false,
			foundHorses: [],
			locationFilter: { id: 0 }
		}
	},
	computed : {
		...mapState({
			horseList: state => state.horses.list
		}),
		tenant() {
			return this.$store.getters['tenant/get']
		},
		locations() {
			let locations = [{ key: 0, value: 'All Locations' }]
	
			 this.$store.getters['locations/list'].forEach(location => {
				locations.push({
					key: location.id,
					value: location.name
				})
			})

			return locations
		},
		horses() {
			return this.horseList.filter(horse => {
				if(this.tenant.hasMultiYard) {
					return this.locationFilter.id === 0 || horse.location_id === this.locationFilter.id	
				}
				return horse
			})
		}
	},
	methods: {
		openAddModal() {
			if(this.tenant.maxHorses && this.horses.length >= this.tenant.maxHorses) {
				this.upgradeOpen = true
			} else {
				this.addOpen = true
			}
		},
		deleteHorse(horse) {
			this.selected = horse
			this.deleteOpen = true
		},
		editHorse(horse) {
			this.selected = horse
			this.editOpen = true
		},
		horseHistory(horse) {
			this.selected = horse
			this.historyOpen = true
		},
		initEquipmentSelected() {
			this.equipmentSelected
		},
		filteredList(items) {
			if(items.length > 0) {
				this.foundHorses = items;
			} 
		}
	},
	mounted() {
		this.$store.commit('app/setLoading', true)
		const horses = this.$store.dispatch('horses/getList')
		const gender = this.$store.dispatch('gender/getList')
		const age = this.$store.dispatch('age/getList')
		const equipment = this.$store.dispatch('equipment/getList')
		const locations = this.$store.dispatch('locations/getList')

		Promise.all([horses, gender, age, equipment, locations])
		.then(() => {
			this.$store.commit('app/setLoading', false);
		})
		.catch(err => {
			this.$store.commit('app/setLoading', false);
			this.$store.dispatch('app/addAlert', {
				type: 'error',
				message: 'An Error occurred, please try later',
				timeout: 3000
			})
		})
	}
}
</script>

<style lang="scss">
.horse-count {
	margin: 6px 10px;
	a, a:hover, a:focus, a:visited {
		color: #009487
	}
}
.location-filter {
	margin-left: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/Horses.vue